import { Flash, Box } from '@acast/decibel';
import React from 'react';
import Container from 'shared/components/content-container';

export default () => (
  <Container>
    <Box p={4}>
      <Flash intent="danger">The page you are looking for cannot be found.</Flash>
    </Box>
  </Container>
);
